import {
  AMOUNT_MAX_DIGITS_MESSAGE,
  MORTGAGE_AMOUNT_INVALID_MESSAGE,
  RENT_AMOUNT_INVALID_MESSAGE,
  RENT_AMOUNT_MAX_DIGITS_MESSAGE,
  RENT_AMOUNT_MIN_SUBMIT_MESSAGE,
  RENT_AMOUNT_MIN_VALUE,
  RENT_AMOUNT_REQUIRED_MESSAGE,
  parseRentAmountNumeric,
  rentAmountExceedsMaxDigits,
} from '@/features/invitee/utils/inviteeValidators'

// Rent/mortgage amount validators owned by the Application module; numeric helpers
// and message constants are reused from invitee's shared (unchanged) exports.
export function validateRentAmountForSubmit(value: string | undefined): string | null {
  if (value == null || String(value).trim() === '') {
    return RENT_AMOUNT_REQUIRED_MESSAGE
  }
  if (rentAmountExceedsMaxDigits(value)) {
    return RENT_AMOUNT_MAX_DIGITS_MESSAGE
  }
  const n = parseRentAmountNumeric(value)
  if (Number.isNaN(n)) {
    return RENT_AMOUNT_INVALID_MESSAGE
  }
  if (n < RENT_AMOUNT_MIN_VALUE) {
    return RENT_AMOUNT_MIN_SUBMIT_MESSAGE
  }
  return null
}

export function validateMortgagePaymentAmount(value: string | undefined | null): string | null {
  if (!String(value ?? '').trim()) return null
  if (rentAmountExceedsMaxDigits(value)) {
    return AMOUNT_MAX_DIGITS_MESSAGE
  }
  const n = parseRentAmountNumeric(String(value))
  if (Number.isNaN(n)) {
    return MORTGAGE_AMOUNT_INVALID_MESSAGE
  }
  return null
}
